
export function abort() {
    $(".ui-dialog-content").dialog("close");
}

export function removeFocus() {
    $(".ui-dialog-content").dialog("close");
}

export function openDialog() {
    $(".ui-dialog-content").dialog("open");
}